var ADOLOPMENT_OPTIONS, AGE, BOOLEAN_OPTIONS, BOOLEAN_OPTIONS_WITH_NOT_REPORTED, CERTAINTIES_OF_EVIDENCE, CHRONIC_PAIN_GENERAL_INFORMATION_FORM_ITEMS, CHRONIC_PAIN_RECOMMENDATION_FORM_ITEMS, CHRONIC_PAIN_WORKSPACE_ID, COUNTRIES, COVID_ASTERIXED_FIELDS, COVID_GENERAL_INFORMATION_FORM_ITEMS, COVID_RECOMMENDATION_FORM_ITEMS, FIELDS, FOCUS, GRADE_HANDBOOK_ADDITIONAL_MATERIALS, GRADE_HANDBOOK_FIELDS, GRADING_OPTIONS, INTENDED_POPULATIONS, INTERVENTION_TYPES, KEY_MESSAGE_RECOMMENDATION_FORM_ITEMS, PCC_MODULES, PLANETARY_HEALTH_RECOMMENDATION_FORM_ITEMS, PLANETARY_HEALTH_WORKSPACE_ID, PLUS, PROGRESS, PROGRESS_FIELDS, PUBLICATION_PLATFORM_GENERAL_INFORMATION_FORM_ITEMS, PUBLICATION_PLATFORM_RECOMMENDATION_FORM_ITEMS, PlainLanguageLinksField, RECOMMENDATION_INTENTS, RECOMMENDATION_INTENTS_WHO, RECOMMENDATION_PATH, RECOMMENDATION_STRENGTHS, SECOND_WORLD_REGION_OPTIONS, SYMPTOMS, TB_RECOMMENDATION_FORM_ITEMS, TYPES_OF_ORGANIZATION, VACCINATION, VERSION_OPTIONS, WORLD_REGIONS, filterOutInformalOrGPS, getMetadataForm, mediator, updateRecommendationWithProgressPlusDataFromGeneralInformationDoc, _ref, _ref1, _ref2;

mediator = require('mediator');

PlainLanguageLinksField = require('components/covid_extraction_form/plain_language_links_field');

_ref = require('lib/extraction_form_helper'), ADOLOPMENT_OPTIONS = _ref.ADOLOPMENT_OPTIONS, AGE = _ref.AGE, BOOLEAN_OPTIONS = _ref.BOOLEAN_OPTIONS, BOOLEAN_OPTIONS_WITH_NOT_REPORTED = _ref.BOOLEAN_OPTIONS_WITH_NOT_REPORTED, CERTAINTIES_OF_EVIDENCE = _ref.CERTAINTIES_OF_EVIDENCE, COUNTRIES = _ref.COUNTRIES, FIELDS = _ref.FIELDS, FOCUS = _ref.FOCUS, GRADE_HANDBOOK_ADDITIONAL_MATERIALS = _ref.GRADE_HANDBOOK_ADDITIONAL_MATERIALS, GRADE_HANDBOOK_FIELDS = _ref.GRADE_HANDBOOK_FIELDS, GRADING_OPTIONS = _ref.GRADING_OPTIONS, INTENDED_POPULATIONS = _ref.INTENDED_POPULATIONS, INTERVENTION_TYPES = _ref.INTERVENTION_TYPES, PCC_MODULES = _ref.PCC_MODULES, PLUS = _ref.PLUS, PROGRESS = _ref.PROGRESS, RECOMMENDATION_INTENTS = _ref.RECOMMENDATION_INTENTS, RECOMMENDATION_INTENTS_WHO = _ref.RECOMMENDATION_INTENTS_WHO, RECOMMENDATION_STRENGTHS = _ref.RECOMMENDATION_STRENGTHS, SECOND_WORLD_REGION_OPTIONS = _ref.SECOND_WORLD_REGION_OPTIONS, SYMPTOMS = _ref.SYMPTOMS, TYPES_OF_ORGANIZATION = _ref.TYPES_OF_ORGANIZATION, VACCINATION = _ref.VACCINATION, VERSION_OPTIONS = _ref.VERSION_OPTIONS, WORLD_REGIONS = _ref.WORLD_REGIONS;

KEY_MESSAGE_RECOMMENDATION_FORM_ITEMS = require('lib/key_message_form_helper').KEY_MESSAGE_RECOMMENDATION_FORM_ITEMS;

TB_RECOMMENDATION_FORM_ITEMS = require('lib/tb_extraction_form_helper').TB_RECOMMENDATION_FORM_ITEMS;

_ref1 = require('lib/chronic_pain_extraction_helper'), CHRONIC_PAIN_RECOMMENDATION_FORM_ITEMS = _ref1.CHRONIC_PAIN_RECOMMENDATION_FORM_ITEMS, CHRONIC_PAIN_GENERAL_INFORMATION_FORM_ITEMS = _ref1.CHRONIC_PAIN_GENERAL_INFORMATION_FORM_ITEMS;

_ref2 = require('lib/planetary_health_extraction_helper'), PLANETARY_HEALTH_RECOMMENDATION_FORM_ITEMS = _ref2.PLANETARY_HEALTH_RECOMMENDATION_FORM_ITEMS, PLANETARY_HEALTH_WORKSPACE_ID = _ref2.PLANETARY_HEALTH_WORKSPACE_ID;

CHRONIC_PAIN_WORKSPACE_ID = require('lib/chronic_pain_helpers').CHRONIC_PAIN_WORKSPACE_ID;

COVID_GENERAL_INFORMATION_FORM_ITEMS = {
  agree: [
    {
      fieldKey: 'scopeAndPurpose',
      type: 'percent'
    }, {
      fieldKey: 'rigorOfDevelopment',
      type: 'percent'
    }, {
      fieldKey: 'editorialProcess',
      type: 'percent'
    }, {
      fieldKey: 'scorePassed',
      type: 'radioOptions',
      options: BOOLEAN_OPTIONS,
      infoText: true
    }
  ],
  main: [
    {
      fieldKey: 'guidelineNoId',
      type: 'text'
    }, {
      fieldKey: 'title',
      type: 'text'
    }, {
      fieldKey: 'authors',
      type: 'text'
    }, {
      fieldKey: 'fullReference',
      type: 'text'
    }, {
      fieldKey: 'publicationDate',
      type: 'date'
    }, {
      fieldKey: 'version',
      type: 'radioOptions',
      options: VERSION_OPTIONS,
      placeholderFromI18n: true
    }, {
      fieldKey: 'source',
      type: 'text',
      placeholderFromI18n: true
    }, {
      fieldKey: 'organizationType',
      type: 'multiSelect',
      options: TYPES_OF_ORGANIZATION
    }, {
      fieldKey: 'sourceDocumentLink',
      type: 'text',
      placeholderFromI18n: true
    }, {
      fieldKey: 'whoIrisId',
      type: 'text'
    }, {
      fieldKey: 'isbn',
      type: 'text'
    }, {
      fieldKey: 'doi',
      type: 'text'
    }, {
      fieldKey: 'pmid',
      type: 'text'
    }, {
      fieldKey: 'guidelineGroupDetails',
      type: 'switchableText',
      options: BOOLEAN_OPTIONS,
      placeholderFromI18n: true
    }, {
      fieldKey: 'declarationOfInterest',
      type: 'radioOptions',
      options: BOOLEAN_OPTIONS,
      helperTextFromI18n: true
    }, {
      fieldKey: 'describedAsRapid',
      type: 'radioOptions',
      options: BOOLEAN_OPTIONS
    }, {
      fieldKey: 'describedAsLiving',
      type: 'radioOptions',
      options: BOOLEAN_OPTIONS
    }, {
      fieldKey: 'includeNonEnglishDatabases',
      type: 'radioOptions',
      options: BOOLEAN_OPTIONS_WITH_NOT_REPORTED
    }, {
      fieldKey: 'latestLiteratureSearchDate',
      type: 'date'
    }, {
      fieldKey: 'gradingEvidenceMethod',
      type: 'radioOptions',
      options: GRADING_OPTIONS,
      placeholderFromI18n: true,
      withOther: true
    }, {
      fieldKey: 'focus',
      type: 'multiSelect',
      options: FOCUS
    }
  ],
  codes: [
    {
      fieldKey: 'guidelineInterventions',
      type: "codes"
    }, {
      fieldKey: 'guidelinePopulations',
      type: "codes"
    }
  ],
  progress: [
    {
      fieldKey: 'progress',
      type: 'multiSelect',
      options: PROGRESS
    }, {
      fieldKey: 'plus',
      type: 'multiSelect',
      options: PLUS
    }, {
      fieldKey: "progressPlus",
      type: 'text'
    }, {
      fieldKey: 'consumerEngagement',
      type: 'switchableText',
      options: BOOLEAN_OPTIONS_WITH_NOT_REPORTED
    }, {
      fieldKey: 'peopleWithLivedExperience',
      type: 'switchableText',
      options: BOOLEAN_OPTIONS
    }, {
      fieldKey: 'targetAudience',
      type: 'text',
      placeholderFromI18n: true
    }, {
      fieldKey: 'field',
      type: 'multiSelect',
      options: FIELDS
    }, {
      fieldKey: 'secondWorldRegionCategory',
      type: 'multiSelect',
      options: SECOND_WORLD_REGION_OPTIONS
    }, {
      fieldKey: 'worldRegion',
      type: 'multiSelect',
      options: WORLD_REGIONS
    }, {
      fieldKey: 'country',
      type: 'multiSelect',
      options: COUNTRIES
    }
  ],
  seo: [
    {
      fieldKey: 'keywords',
      type: 'text',
      placeholderFromI18n: true
    }
  ]
};

PUBLICATION_PLATFORM_GENERAL_INFORMATION_FORM_ITEMS = {
  main: [
    {
      fieldKey: 'title',
      showClear: false,
      type: 'text'
    }, {
      fieldKey: 'slug',
      helperTextFromI18n: true,
      showClear: false,
      type: 'text'
    }, {
      fieldKey: 'generalDescription',
      showClear: false,
      type: 'editorText'
    }, {
      fieldKey: 'authors',
      type: 'text'
    }, {
      fieldKey: 'fullReference',
      type: 'text'
    }, {
      fieldKey: 'publicationDate',
      type: 'date'
    }, {
      fieldKey: 'version',
      type: 'radioOptions',
      options: VERSION_OPTIONS,
      placeholderFromI18n: true
    }, {
      fieldKey: 'source',
      type: 'text',
      placeholderFromI18n: true
    }, {
      fieldKey: 'sourceDocumentLink',
      type: 'text',
      placeholderFromI18n: true
    }, {
      fieldKey: 'isbn',
      type: 'text'
    }, {
      fieldKey: 'doi',
      type: 'text'
    }, {
      fieldKey: 'pmid',
      type: 'text'
    }, {
      fieldKey: 'latestLiteratureSearchDate',
      type: 'date'
    }, {
      fieldKey: 'targetAudience',
      type: 'text',
      placeholderFromI18n: true
    }, {
      fieldKey: 'field',
      type: 'multiSelect',
      options: FIELDS
    }
  ]
};

COVID_RECOMMENDATION_FORM_ITEMS = {
  main: [
    {
      fieldKey: 'age',
      type: 'multiSelect',
      options: AGE
    }, {
      fieldKey: 'recommendationIntent',
      type: 'select',
      options: RECOMMENDATION_INTENTS
    }, {
      fieldKey: 'canPCCModule',
      type: 'select',
      options: PCC_MODULES
    }, {
      fieldKey: 'publicationDate',
      type: 'date'
    }, {
      fieldKey: 'authors',
      type: 'editorText'
    }, {
      fieldKey: 'recommendationIntentWHO',
      type: 'select',
      options: RECOMMENDATION_INTENTS_WHO,
      featureSwitch: 'show_who_covid_intents'
    }, {
      fieldKey: 'coexistingCondition',
      type: 'text',
      placeholderFromI18n: true,
      helperTextFromI18n: true
    }, {
      fieldKey: 'intendedPopulation',
      type: 'multiSelect',
      options: INTENDED_POPULATIONS
    }, {
      fieldKey: 'informal',
      type: 'switcher'
    }, {
      fieldKey: 'research',
      type: 'switcher'
    }, {
      fieldKey: 'reportedAsGPS',
      type: 'switcher'
    }, {
      fieldKey: 'adapted',
      type: 'switcher',
      hide: function() {
        return mediator.activeWorkspace === 'o_can_pcc_0';
      }
    }, {
      fieldKey: 'adolopment',
      type: 'select',
      options: ADOLOPMENT_OPTIONS
    }, {
      fieldKey: 'transformed',
      type: 'switcher'
    }, {
      fieldKey: 'gradingEvidenceMethod',
      type: 'radioOptions',
      options: GRADING_OPTIONS,
      placeholderFromI18n: true,
      withOther: true
    }, {
      fieldKey: 'sofSupplemented',
      type: 'switcher'
    }, {
      fieldKey: 'etdModified',
      type: 'switcher'
    }, {
      fieldKey: 'certaintyOfEvidence',
      type: 'selectWithOther',
      options: CERTAINTIES_OF_EVIDENCE,
      placeholderFromI18n: true
    }, {
      fieldKey: 'strengthOfRecommendation',
      type: 'selectWithOther',
      options: RECOMMENDATION_STRENGTHS,
      placeholderFromI18n: true
    }, {
      fieldKey: 'expertComment',
      type: 'editorText'
    }, {
      fieldKey: 'plainLanguageSummaryDescription',
      type: 'editorText'
    }, {
      fieldKey: 'plainLanguageSummary',
      type: 'custom',
      customWithArray: true,
      component: PlainLanguageLinksField,
      showClear: false
    }, {
      fieldKey: 'relatedRecommendationLinks',
      type: 'custom',
      customWithArray: true,
      component: PlainLanguageLinksField,
      showClear: false,
      additionalProps: {
        addBtnLabel: $.t('/actions.add_related_recommendation')
      }
    }, {
      fieldKey: 'individualRecommendation',
      type: 'text',
      placeholderFromI18n: true
    }, {
      fieldKey: 'evidenceTableUrl',
      type: 'text',
      placeholderFromI18n: true
    }, {
      fieldKey: 'loveUrl',
      type: 'text',
      placeholderFromI18n: true
    }, {
      fieldKey: 'emlUrl',
      type: 'multiText',
      placeholderFromI18n: true,
      addValueLabel: $.t('actions.add_link')
    }, {
      fieldKey: 'symptoms',
      type: 'multiSelect',
      options: SYMPTOMS
    }, {
      fieldKey: 'vaccination',
      type: 'select',
      options: VACCINATION
    }, {
      fieldKey: 'interventionTypes',
      type: 'select',
      options: INTERVENTION_TYPES
    }, {
      fieldKey: 'hospitalization',
      type: 'radioOptions',
      options: BOOLEAN_OPTIONS_WITH_NOT_REPORTED
    }
  ],
  progress: [
    {
      fieldKey: 'progress',
      type: 'multiSelect',
      options: PROGRESS
    }, {
      fieldKey: 'plus',
      type: 'multiSelect',
      options: PLUS
    }, {
      fieldKey: "progressPlus",
      type: 'text'
    }
  ],
  seo: [
    {
      fieldKey: 'keywords',
      type: 'text',
      placeholderFromI18n: true
    }
  ]
};

PUBLICATION_PLATFORM_RECOMMENDATION_FORM_ITEMS = {
  main: [
    {
      fieldKey: 'age',
      type: 'multiSelect',
      options: AGE
    }, {
      fieldKey: 'recommendationIntent',
      type: 'select',
      options: RECOMMENDATION_INTENTS
    }, {
      fieldKey: 'coexistingCondition',
      type: 'text',
      placeholderFromI18n: true,
      helperTextFromI18n: true
    }, {
      fieldKey: 'intendedPopulation',
      type: 'multiSelect',
      options: INTENDED_POPULATIONS
    }, {
      fieldKey: 'informal',
      type: 'switcher'
    }, {
      fieldKey: 'research',
      type: 'switcher'
    }, {
      fieldKey: 'adapted',
      type: 'switcher'
    }, {
      fieldKey: 'transformed',
      type: 'switcher'
    }, {
      fieldKey: 'certaintyOfEvidence',
      type: 'selectWithOther',
      options: CERTAINTIES_OF_EVIDENCE,
      placeholderFromI18n: true
    }, {
      fieldKey: 'strengthOfRecommendation',
      type: 'selectWithOther',
      options: RECOMMENDATION_STRENGTHS,
      placeholderFromI18n: true
    }, {
      fieldKey: 'plainLanguageSummary',
      type: 'custom',
      customWithArray: true,
      component: PlainLanguageLinksField,
      showClear: false
    }
  ]
};

PROGRESS_FIELDS = ['progress', 'plus', 'progressPlus'];

RECOMMENDATION_PATH = ['templateData', 'conclusions', 'sections', 'recommendation'];

updateRecommendationWithProgressPlusDataFromGeneralInformationDoc = function(recommendationDoc, generalInformationDoc) {
  var immDoc, updatedDoc;
  immDoc = Immutable.fromJS(recommendationDoc);
  updatedDoc = _.reduce(PROGRESS_FIELDS, function(acc, field) {
    var generalInformationDocValue;
    generalInformationDocValue = generalInformationDoc[field];
    if (!generalInformationDocValue) {
      return acc;
    }
    return acc.setIn(_.union(RECOMMENDATION_PATH, [field]), generalInformationDocValue);
  }, immDoc);
  return updatedDoc.toJS();
};

COVID_ASTERIXED_FIELDS = ['age', 'authors', 'certaintyOfEvidence', 'consumerEngagement', 'declarationOfInterest', 'describedAsLiving', 'describedAsRapid', 'emlUrl', 'evidenceTableUrl', 'field', 'focus', 'fullReference', 'gradingEvidenceMethod', 'guidelineGroupDetails', 'guidelineNoId', 'includeNonEnglishDatabases', 'individualRecommendation', 'informal', 'intendedPopulation', 'latestLiteratureSearchDate', 'publicationDate', 'recommendationIntent', 'research', 'secondWorldRegionCategory', 'source', 'sourceDocumentLink', 'strengthOfRecommendation', 'targetAudience', 'title', 'whoIrisId', 'recommendationIntentWHO'];

filterOutInformalOrGPS = function(form, templateId) {
  var main, sectionToFilteredOut, _ref3;
  sectionToFilteredOut = templateId === 'good-practice-statement' ? 'informal' : 'reportedAsGPS';
  main = _.filter((_ref3 = form != null ? form.main : void 0) != null ? _ref3 : [], function(_arg) {
    var fieldKey;
    fieldKey = _arg.fieldKey;
    return fieldKey !== sectionToFilteredOut;
  });
  return _.extend({
    main: main
  }, _.omit(form, 'main'));
};

getMetadataForm = function(templateId) {
  var isCadthServerSwitchOn, isChronicPainServerSwitchOn, isCovidServerSwitchOn, isEcServerSwitchOn, isPlanetaryHealthServerSwitchOn, isPublicationPlatformSwitchOn, isTbServerSwitchOn, switchesService;
  switchesService = mediator.services.switches;
  isEcServerSwitchOn = switchesService.isServerSwitchOn('ecFeatures');
  isCovidServerSwitchOn = switchesService.isServerSwitchOn('covidFeatures');
  isCadthServerSwitchOn = switchesService.isServerSwitchOn('cadthFeatures');
  isTbServerSwitchOn = switchesService.isServerSwitchOn('tbFeatures');
  isPublicationPlatformSwitchOn = switchesService.isOn('publicationPlatform');
  isPlanetaryHealthServerSwitchOn = switchesService.isServerSwitchOn('planetaryHealthFeatures') || mediator.activeWorkspace === PLANETARY_HEALTH_WORKSPACE_ID;
  isChronicPainServerSwitchOn = switchesService.isServerSwitchOn('chronicPainFeatures') || mediator.activeWorkspace === CHRONIC_PAIN_WORKSPACE_ID;
  if (isCovidServerSwitchOn) {
    return filterOutInformalOrGPS(COVID_RECOMMENDATION_FORM_ITEMS, templateId);
  } else if (isChronicPainServerSwitchOn) {
    return CHRONIC_PAIN_RECOMMENDATION_FORM_ITEMS;
  } else if (isCadthServerSwitchOn) {
    return KEY_MESSAGE_RECOMMENDATION_FORM_ITEMS;
  } else if (isTbServerSwitchOn) {
    return TB_RECOMMENDATION_FORM_ITEMS;
  } else if (isPlanetaryHealthServerSwitchOn) {
    return PLANETARY_HEALTH_RECOMMENDATION_FORM_ITEMS;
  } else if (isPublicationPlatformSwitchOn || isEcServerSwitchOn) {
    return filterOutInformalOrGPS(PUBLICATION_PLATFORM_RECOMMENDATION_FORM_ITEMS, templateId);
  } else {
    return null;
  }
};

module.exports = {
  COVID_GENERAL_INFORMATION_FORM_ITEMS: COVID_GENERAL_INFORMATION_FORM_ITEMS,
  COVID_RECOMMENDATION_FORM_ITEMS: COVID_RECOMMENDATION_FORM_ITEMS,
  CHRONIC_PAIN_GENERAL_INFORMATION_FORM_ITEMS: CHRONIC_PAIN_GENERAL_INFORMATION_FORM_ITEMS,
  COVID_ASTERIXED_FIELDS: COVID_ASTERIXED_FIELDS,
  GRADE_HANDBOOK_FIELDS: GRADE_HANDBOOK_FIELDS,
  GRADE_HANDBOOK_ADDITIONAL_MATERIALS: GRADE_HANDBOOK_ADDITIONAL_MATERIALS,
  PUBLICATION_PLATFORM_GENERAL_INFORMATION_FORM_ITEMS: PUBLICATION_PLATFORM_GENERAL_INFORMATION_FORM_ITEMS,
  PUBLICATION_PLATFORM_RECOMMENDATION_FORM_ITEMS: PUBLICATION_PLATFORM_RECOMMENDATION_FORM_ITEMS,
  updateRecommendationWithProgressPlusDataFromGeneralInformationDoc: updateRecommendationWithProgressPlusDataFromGeneralInformationDoc,
  getMetadataForm: getMetadataForm
};
